import { forkJoin, interval, Subscription } from 'rxjs';
import { SharedService } from './services/shared.service';
import { Component, HostListener, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { AccountService } from './services/account.service';
import { NavigationStart, Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EventsService } from './services/events.service';
import { ToastService } from './services/toast.service';

@UntilDestroy()
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styles: [],
})
export class MainComponent implements OnInit, OnDestroy {
    constructor(
        public sharedService: SharedService,
        private LocalStorage: LocalStorage,
        private router: Router,
        private accountService: AccountService,
        private eventsService: EventsService,
        public toastService: ToastService
    ) {}

    hideCloak: boolean;

    async ngOnInit() {
        this.onResize();
        this.setSideNavState();
        this.setUrlState();

        let connection = new signalR.HubConnectionBuilder().withUrl(`/notificationsHub?userId=${this.accountService.currentUser.id}`).build();

        connection.on('newOrder', (data) => {
            this.eventsService.trigger.next({ name: 'newOrder', value: data });
        });

        await connection.start();

        // this.clearToastsInterval();
    }

    isTemplate(toast: any) {
        return toast.textOrTpl instanceof TemplateRef;
    }

    @HostListener('window:afterprint')
    onafterprint() {
        document.getElementById('receipt-print-target-area').innerHTML = '';
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if (window.innerWidth <= 768) {
            this.sharedService.sidebarOpen = false;
        }
    }

    setSideNavState() {
        let sidebarOpen = this.LocalStorage.getItem('sidebarOpen');

        let sidebarItems = this.LocalStorage.getItem('sidebarItems');

        forkJoin([sidebarOpen, sidebarItems]).subscribe((data: any) => {
            if (data[0] != undefined) {
                if (window.innerWidth > 768) {
                    this.sharedService.sidebarOpen = data[0];
                }
            }

            if (data[1] != undefined) {
                if (window.innerWidth > 768) {
                    data[1].forEach((element: any) => {
                        element.isOpenMobile = false;
                    });
                }

                data[1].forEach((element: any) => {
                    let item = this.sharedService.sidebarItems.find((c) => c.name === element.name);
                    if (item) {
                        item.isOpen = element.isOpen;
                    }
                });
            }

            this.hideCloak = true;

            this.sharedService.setState();
        });
    }

    setUrlState() {
        this.sharedService.currentUrl = this.router.url;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.sharedService.previousUrl = this.sharedService.currentUrl;
                this.sharedService.currentUrl = event.url;
            }
        });
    }

    ngOnDestroy(): void {}
}
